import {EventEmitter, Injectable} from '@angular/core';
import {v4 as uuid} from 'uuid';
import * as sha256 from 'sha256';

declare const Proxy: any;
// declare const TextEncoder: any;

class Changes {
    private readonly before;

    constructor(private target, private prop, private value) {
        this.before = target[prop];
        this.target[prop] = value;
    }

    cancel() {
        this.target[this.prop] = this.before;
    }
}

export class ChangesSubject {
    private readonly id: string;
    private proxy: any;
    private handlers: Array<any> = [];
    private changes: Array<Changes> = [];
    private readonly _onChanges: EventEmitter<any>;
    private original: any;

    constructor(private o: any) {
        this.original = Object.create(o);
        this.id = uuid();
        this._onChanges = new EventEmitter();
        this.proxy = this.createProxy(o);
    }

    getProxy() {
        return this.proxy;
    }

    cancelChanges() {
        this.changes.reverse().forEach((change) => {
            change.cancel();
        });
        this.handlers.forEach((h) => {
            h.changed = false;
        });
        this.changes = [];
        this.onChanges.emit({target: this.proxy, subject: this});
    }

    get onChanges(): EventEmitter<any> {
        return this._onChanges;
    }

    get changesCount() {
        let count = 0;
        for (let i = 0; i < this.handlers.length; i++) {
            const handler = this.handlers[i];
            if (handler.changed) {
                count++;
            }
        }
        return count;
    }

    private createProxy(object) {
        if (object instanceof Array) {
            object = object.map((o) => this.createProxy(o));
        } else if (typeof object === 'object' && object !== null) {
            Object.keys(object).forEach((key) => {
                object[key] = this.createProxy(object[key]);
            });
        } else {
            return object;
        }

        const handler = {
            changed: false,
            original: Object.assign({}, object),
            set: async (obj, prop, value) => {
                this.changes.push(new Changes(obj, prop, value));
                if (prop !== '__id') {
                    const original = await this.getHash(JSON.stringify(handler.original));
                    const mutable = await this.getHash(JSON.stringify(obj));
                    handler.changed = (original !== mutable);
                    this.onChanges.emit({target: obj, prop, value, subject: this});
                }
                return true;
            }
        };

        this.handlers.push(handler);

        return new Proxy(object, handler);
    }

    private getHash(str, algo = 'SHA-256') {
        return Promise.resolve(sha256(str));
    }

    // crypto.subtle available only with https

    // private getHash(str, algo = 'SHA-256') {
    //     let strBuf = new TextEncoder('utf-8').encode(str);
    //     return crypto.subtle.digest(algo, strBuf)
    //         .then(hash => {
    //             let result = '';
    //             const view = new DataView(hash);
    //             for (let i = 0; i < hash.byteLength; i += 4) {
    //                 result += ('00000000' + view.getUint32(i).toString(16)).slice(-8);
    //             }
    //             return result;
    //         });
    // }
}

@Injectable()
export class DataChangesObserver {
    private _onChanges: EventEmitter<any>;

    constructor() {
        this._onChanges = new EventEmitter();
    }

    get onChanges(): EventEmitter<any> {
        return this._onChanges;
    }

    observe(data: any): ChangesSubject {
        return new ChangesSubject(data);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/utils/DataChangesObserver.ts